// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3z3PX","title":"Images90_title__7Gh2a","images":"Images90_images__1jRjI"};